import React from 'react';

// Parents
import TimesheetsTabs from './dash-backoffice-tabs';
import TimesheetsRoutes from './dash-backoffice-routes';

export default function (props) {

  return (
    <TimesheetsTabs>
      <TimesheetsRoutes />
    </TimesheetsTabs>
  )
}
